define('presentation/settings/outboundCallingCampaigns/facades/addOutboundCallingCampaignFacade',[
    'common/storage/commonState',
    'externalDependencies/clientWebSocket',
    'presentation/settings/outboundCallingCampaigns/presentationObjects/outboundCallingCampaignPresentationObject'
], function () {
    const OutboundCallingCampaignPresentationObjectConstructor = require('presentation/settings/outboundCallingCampaigns/presentationObjects/outboundCallingCampaignPresentationObject');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const outboundCampaignSocket = clientWebSocket.forApplication("outboundCallingCampaign");
    const liveReceptionistScriptSocket = clientWebSocket.forApplication("liveReceptionistScript");

    const _commonState = require('common/storage/commonState');

    let _promiseFactory = null;

    const _buildOutboundCallingCampaignPresentationObject = (campaign) => {
        const outboundCallingCampaignPresentationObject = new OutboundCallingCampaignPresentationObjectConstructor();
        outboundCallingCampaignPresentationObject.outboundCallingCampaignId = campaign.outboundCallingCampaignId;
        outboundCallingCampaignPresentationObject.name = campaign.name;
        outboundCallingCampaignPresentationObject.campaignCode = campaign.campaignCode;
        outboundCallingCampaignPresentationObject.active = campaign.active;
        outboundCallingCampaignPresentationObject.outboundCallerId = campaign.outboundCallerId;
        outboundCallingCampaignPresentationObject.genesysCampaignId = campaign.genesysCampaignId;
        outboundCallingCampaignPresentationObject.liveReceptionistScriptId = campaign.liveReceptionistScriptId;
        return outboundCallingCampaignPresentationObject;
    };

    const _getLiveReceptionistScripts = () => {
        return _promiseFactory.defer((promise) => {
            liveReceptionistScriptSocket.send("retrieveAll", {}, (liveReceptionistScripts) => {
                const scripts = liveReceptionistScripts.map((liveReceptionistScript) => {
                    const { liveReceptionistScriptId, name, status, type } = liveReceptionistScript;
                    return {
                        id: liveReceptionistScriptId,
                        name: name,
                        status: status,
                        scriptType: type,
                        type: _commonState.types.liveReceptionistScript
                    };
                });
                promise.resolve(scripts);
            });
        });
    };

    const _getOutboundCallingCampaign = (outboundCallingCampaignId) => {
        return _promiseFactory.defer((promise) => {
            outboundCampaignSocket.send('getOutboundCallingCampaign', { outboundCallingCampaignId }, response => {
                const outboundCallingCampaignPresentationObject = _buildOutboundCallingCampaignPresentationObject(response);
                promise.resolve(outboundCallingCampaignPresentationObject);
            });
        });
    };

    const _createOutboundCallingCampaign = (newOutboundCallingCampaign) => {
        return _promiseFactory.defer((promise) => {
            const newCampaignRequest = {
                outboundCallingCampaignId: newOutboundCallingCampaign.outboundCallingCampaignId,
                name: newOutboundCallingCampaign.name,
                campaignCode: newOutboundCallingCampaign.campaignCode,
                outboundCallerId: newOutboundCallingCampaign.outboundCallerId,
                liveReceptionistScriptId: newOutboundCallingCampaign.liveReceptionistScriptId
            };
            outboundCampaignSocket.send('createOutboundCallingCampaign', newCampaignRequest, response => {
                const outboundCallingCampaignPresentationObject = _buildOutboundCallingCampaignPresentationObject(response);
                promise.resolve(outboundCallingCampaignPresentationObject);
            });
        });
    };

    const _updateOutboundCallingCampaign = (updatedOutboundCallingCampaign) => {
        return _promiseFactory.defer((promise) => {
            const updateCampaignRequest = {
                outboundCallingCampaignId: updatedOutboundCallingCampaign.outboundCallingCampaignId,
                name: updatedOutboundCallingCampaign.name,
                outboundCallerId: updatedOutboundCallingCampaign.outboundCallerId,
                liveReceptionistScriptId: updatedOutboundCallingCampaign.liveReceptionistScriptId
            };
            outboundCampaignSocket.send('updateOutboundCallingCampaign', updateCampaignRequest, response => {
                const outboundCallingCampaignPresentationObject = _buildOutboundCallingCampaignPresentationObject(response);
                promise.resolve(outboundCallingCampaignPresentationObject);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function () {
        const self = this;
        self.init = _init;
        self.createOutboundCallingCampaign = _createOutboundCallingCampaign;
        self.getLiveReceptionistScripts = _getLiveReceptionistScripts;
        self.getOutboundCallingCampaign = _getOutboundCallingCampaign;
        self.updateOutboundCallingCampaign = _updateOutboundCallingCampaign;
    };
});

